import { atom } from "recoil";

export const addStateOfficeBrand = atom({
  key: "addStateOfficeBrand",
  default: false,
});
export const editStateOfficeBrand = atom({
  key: "editStateOfficeBrand",
  default: false,
});
export const disableButtonStateOfficeBrand = atom({
  key: "disableButtonStateOfficeBrand",
  default: false,
});

export const selectedRowsStateOfficeBrand = atom({
  key: "selectedRowsStateOfficeBrand",
  default: [],
});

export const setFilterTextOfficeBrand = atom({
  key: "setFilterTextOfficeBrand",
  default: "",
});
